<div class="container text-center">
  @if ((theme$ | async) === "light") {
    <img src="assets/img/forbidden.png" alt="forbidden" />
  } @else {
    <img src="assets/img/forbidden-dt.png" alt="forbidden" />
  }

  <h3 class="mt-3">{{ "COMPONENTS.FORBIDDEN.HEADER" | translate }}</h3>

  <p>{{ "COMPONENTS.FORBIDDEN.TEXT1" | translate }}</p>
  <p>{{ "COMPONENTS.FORBIDDEN.TEXT2" | translate }}</p>
</div>
